import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface LiveLogEntry {
  Id: number;
  Timestamp: string;
  Level: string;
  Message: string;
  Exception?: string;
}

@Injectable({ providedIn: 'root' })
export class LiveLogService {
  private http = inject(HttpClient);

  get(criteria: any = {}) {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(criteria)) {
      if (value !== null && value !== undefined && value !== '') params = params.set(key, value as string);
    }
    return firstValueFrom(this.http.get<LiveLogEntry[]>('/api/live-log', { params }));
  }
}
